<template>
  <div
    class="dlrLeftFloor"
    v-if="sceneFloorNums.length > 1 && callStatus !== 2 && !isSHowSmartGuide"
  >
    <ul>
      <li
        @click="gotoFloor(item)"
        :class="{ active: currentFloorIndex === item }"
        v-for="item in sceneFloorNums"
        :key="item"
      >
        <span>{{ item }}层</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import queryParams from '../services/pageQuery.service';
import { URLService } from '../services/url.service';
export default {
  data() {
    return {
      currentFloorIndex: queryParams.floor,
    };
  },
  props: {
    isSHowSmartGuide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo',
      callStatus: 'callStatus/callStatus',
    }),
    sceneFloorNums() {
      return this.baseInfo?.fdRight?.sceneFloorNums.reverse() || [];
    },
  },
  watch: {
    sceneFloorNums: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          if (!queryParams.floor) {
            this.currentFloorIndex = newVal[newVal.length - 1];
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    gotoFloor(item) {
      if (item === this.currentFloorIndex) {
        return;
      }
      const urlService = new URLService( window.location.href) ;
      urlService.queryParams.replace('floor', String(item),true);

      // 刷新页面
      // window.location.href = href;
      window.location.replace(urlService.build());
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/modules/_leftFloor.scss';
</style>
